import React, { Component } from 'react';
import { connect } from 'react-redux';
// import LaddaButton, { ZOOM_IN } from 'react-ladda';
import { Button, Icon } from 'antd';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr'
import * as actionCreators from '../../../../actions/customer';
import * as actionUser from './../../../../actions/user';

@connect(
  state => ({
    customers: state.get('Customer'),
    userState: state.get('User')
  }),
  dispatch => ({
    customerAction: bindActionCreators(actionCreators, dispatch),
    UserAction: bindActionCreators(actionUser, dispatch)
  })
)
export default class RegisterUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: ''
    };
  }
  componentWillMount() {
    const { customerAction } = this.props;
    customerAction.fetchCustomerNameList({});
  }
  // props 改变时调用
  componentWillReceiveProps(nextProps) {
    const { customers } = nextProps;
    const { data } = (customers && customers.toJS().data) || {};
    this.setState({ customerName: data });
  }
  // 设置经销商
  setCustomer = (value) => { this.setState({ customer: value }) }
  // 设置用户类型
  setType = (value) => { this.setState({ type: value }) }
  typein = field => (e) => {
    this.setState({ [field]: e.target.value });
  }
  submit = () => {
    const { UserAction } = this.props;
    const { customer, type, username, phone } = this.state;
    if (customer && type && username && phone) {
      const params = {
        customerId: customer.id,
        username: username,
        phone: phone,
        role: type.id
      }
      UserAction.fetchRegistar(params)
        .then(() => {
          const { userState } = this.props;
          const data = userState.get('data');
          if (data.get('success')) {
            toastr.success(data.get('message'));
          } else {
            toastr.error('错误信息', data.get('message'));
          }
        })
        .catch(() => { })
    } else {
      toastr.error('错误信息', '请输入用户信息！');
    }
  }
  render() {
    const { customer, customerName, type } = this.state;
    return (
      <div className="container" style={{ marginTop: '10px', background: './timg.jpg' }}>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="mx-2">
              <div className="p-2">
                <h2 style={{ marginBottom: '60px' }}>迪乐扫扫-用户注册</h2>
                <p className="text-muted">{' '}</p>
                <div className="input-group mb-2">
                  <span className="input-group-addon"><Icon type="code-o" /></span>
                  <Select
                    className="form-control"
                    placeholder="选择用户类型"
                    labelKey="name"
                    valueKey="id"
                    value={type || ''}
                    options={[{ id: '3', name: '审计人员' }, { id: '4', name: '经销商' }]}
                    onChange={e => this.setType(e)}
                  />
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-addon"><Icon type="code-o" /></span>
                  <Select
                    placeholder="选择对应经销商"
                    className="form-control"
                    labelKey="name"
                    valueKey="id"
                    value={customer || ''}
                    options={customerName}
                    onChange={e => this.setCustomer(e)}
                  />
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-addon"><Icon type="user" /></span>
                  <input type="text" className="form-control" onChange={this.typein('username')} placeholder="用户名" />
                </div>
                <div className="input-group mb-2">
                  <span className="input-group-addon"><Icon type="phone" /></span>
                  <input type="text" className="form-control" onChange={this.typein('phone')} placeholder="电话" />
                </div>
                <div className="p-1">
                  <div className="row">
                    <Button className="btn btn-block btn-primary" onClick={this.submit}><span>新增</span></Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/App/User/RegisterUser/index.js